// this file is auto-generated. do not edit manually.
// generated by scripts/generate-artifacts.ts

export const InstructionAction = {
  DeactivateInstruction: "deactivateInstruction",
  RefuelERC20: "refuelERC20",
  Refuel: "refuel",
  SweepDepositAccountERC20: "sweepDepositAccountERC20",
  SweepDepositAccount: "sweepDepositAccount",
  SweepSkipCCTPDepositAccount: "sweepSkipCCTPDepositAccount",
  TransferERC20: "transferERC20",
  Transfer: "transfer",
  UniswapV3ExactInput: "uniswapV3ExactInput",
} as const;
export type InstructionAction =
  (typeof InstructionAction)[keyof typeof InstructionAction];

export type InstructionActionType = typeof InstructionAction;
export type InstructionActionKey = keyof InstructionActionType;
export type InstructionActionValue =
  InstructionActionType[InstructionActionKey];
